import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type LayoutFillParentCenteredProps = BoxProps;

const testId = "LayoutFillParentCentered";
const LayoutFillParentCentered = (props: LayoutFillParentCenteredProps) => {
    const { sx, children, className, ...otherProps } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                ...sx,
            }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export default LayoutFillParentCentered;
